import { useCallback, useEffect, useRef, useState } from 'react';
import {
  Checkbox,
  FormControlLabel,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { ehandoverAPI } from '../../../../../apis';
import { i18n } from '../../../../../language';
import { getArrayRandomKey } from '../../../../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#fff',
    padding: '1.875rem',
    borderRadius: '0 0.93rem 0.93rem 0.93rem',
  },
  tableContainer: {
    height: '65vh',
  },
  table: {
    position: 'relative',
    minWidth: '45rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '1.125rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0 1rem ',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
        textTransform: 'uppercase',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        padding: '1rem',
        backgroundColor: '#fff',
        fontSize: '0.875rem',
      },
      '& .MuiTableCell-root:nth-child(1)': {
        paddingLeft: '1.313rem',
      },
      '& .MuiTableCell-root:nth-last-child(1)': {
        paddingRight: '1.883rem',
      },
    },
    '& .MuiTableBody-root': {
      '& :hover': {
        backgroundColor: '#f5faff',
      },
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #E6E8E9',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
      '& .MuiTableCell-root:nth-child(1)': {
        paddingLeft: '1.313rem',
      },
      '& .MuiTableCell-root:nth-last-child(1)': {
        paddingRight: '1.883rem',
      },
    },
  },
  tableHead: {
    whiteSpace: 'nowrap',
  },
  add: {
    width: '5.688rem',
    height: '3rem',
    background: '#538fff',
    color: '#fff',
    borderRadius: '0.625rem',
    fontWeight: '500',
    fontFamily: 'NotoSans-Medium',
  },
  checkBox: {
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
}));

export default function AccessControl() {
  const classes = useStyles();
  const [accessList, setAccessList] = useState([]);
  const language = useSelector((state) => state.settings.language);
  const loginInfo = useSelector((state) => state.loginInfo);
  const tableRef = useRef();

  const getAccessControlListAPI = useCallback(async () => {
    try {
      const { result } = await ehandoverAPI.getSettingAccess({});
      const list = [
        {
          text: i18n.t('EHANDOVER_REQUIRE_LOGIN_COMPLETE_CHECKLIST'),
          isChecked: result?.isLoginUpdateItemYn === 'Y',
          type: 'COMPLETE_CHECKLIST_ITEM',
        },
        {
          text: i18n.t('EHANDOVER_REQUIRE_LOGIN_UPDATE_NOTES'),
          isChecked: result?.isLoginAddNotesYn === 'Y',
          type: 'ADD_UPDATE_NOTES',
        },
      ];
      setAccessList(list);
    } catch (error) {}
  }, []);

  const updateAccessControl = async (rowItem, isChecked) => {
    try {
      const newAccessList = _.map(accessList, (item) => ({
        ...item,
        isChecked: item.type === rowItem.type ? isChecked : item.isChecked,
      }));
      await ehandoverAPI.updateSettingAccess({
        isLoginUpdateItemYn: newAccessList?.[0]?.isChecked ? 'Y' : 'N',
        isLoginAddNotesYn: newAccessList?.[1]?.isChecked ? 'Y' : 'N',
      });
      setAccessList(newAccessList);
      await getAccessControlListAPI();
    } catch (error) {}
  };

  useEffect(() => {
    getAccessControlListAPI();
  }, [language,loginInfo?.wardId]);

  return (
    <div className={classes.root}>
      <TableContainer className={classes.tableContainer} ref={tableRef}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead} id="bed_setting_table_head">
            <TableRow>
              <TableCell align="left" style={{ wordBreak: 'break-all' }}>
                {i18n.t('EHANDOVER_ACCESS_CONTROL_ITEM')}
              </TableCell>
              <TableCell align="center">{i18n.t('BEDSTATUS_ACTIVE')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody id="bed_setting_table_body">
            {accessList.map((row, rowIndex) => {
              return (
                <TableRow
                  key={getArrayRandomKey(rowIndex, 'ehandover-access-control')}
                  id={`e_handover_setting_table_row${rowIndex}`}
                >
                  <TableCell align="left">{row?.text}</TableCell>
                  <TableCell align="center">
                    <FormControlLabel
                      id="edit_access_control_checkbox"
                      control={<Checkbox />}
                      label=""
                      className={classes.checkBox}
                      checked={row?.isChecked}
                      onChange={(event) => updateAccessControl(row, event.target.checked)}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
